import React from "react";
import PropTypes from "prop-types";

export const CommunityChatBox = ({
  locals,
  chatboxEl,
  mobileChatOpened,
  setMobileChatOpened,
}) => {
  const { activeUser } = locals;
  const { webAppTheme = "dark" } = activeUser;
  return (
    <div
      className={
        webAppTheme == "dark"
          ? `dark-conversation-container conversation-container`
          : `light-conversation-container conversation-container`
      }
    >
      <button
        className="only-show-mobile chat-back"
        onClick={() => setMobileChatOpened(false)}
      >
        <img
          alt="back"
          src="/img/new-icons/arrow-square-left.svg"
          className={webAppTheme === "dark" ? "filter-white" : "filter-black"}
        />
        <span>Back</span>
      </button>

      <div
        className={
          mobileChatOpened ? "chat-box chat-box-mobile-chat-opened" : "chat-box"
        }
        ref={chatboxEl}
      >
        <img src="/img/spinner.gif" width="50" height="50" alt="spinner" />
      </div>
    </div>
  );
};

CommunityChatBox.propTypes = {
  locals: PropTypes.object,
  chatboxEl: PropTypes.any,
  mobileChatOpened: PropTypes.bool,
  setMobileChatOpened: PropTypes.func,
};